<template>
    <div>
        <b-card no-body>
          <b-tabs card pills vertical nav-wrapper-class="w-40" v-model="tabIndex">
            <b-tab>
                <template slot="title">
                    General
                </template>
            </b-tab>
             <b-tab>
                <template slot="title">
                    Settings
                </template>
                
                <b-row>
                    <b-col md="4">
                        <b-card>
                            <div slot="header">Host</div>

                            <b-form-group
                                label="Hostname"
                            >
                                <b-input-group>
                                    <b-form-input type="text" v-model="settings.hostname" :disabled="settings.hostname != ''"> </b-form-input>
                                    <b-input-group-append>
                                        <b-input-group-text>.ptkl.shop</b-input-group-text>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-card>
                    </b-col>

                    <b-col md="4">
                        <b-card >
                            <div slot="header">Customization</div>

                            <ImageField type="imagev2" v-model="logo" name="logo" :rules={} label="Logo" :publicUpload="true"/>

                            <b-col xs="12">
                                <b-form-group
                                    label="Brand primary color"
                                    
                                >
                                    <b-input type="color" v-model="settings.settings.brand.primary_color" />
                                
                                </b-form-group>
                            </b-col>
                            <b-col xs="12">
                                <b-form-group
                                    label="Brand secondary color"
                                    
                                >
                                    <b-input type="color" v-model="settings.settings.brand.secondary_color" />
                                
                                </b-form-group>
                            </b-col>
                        </b-card>
                    </b-col>

                    <b-col md="4">
                        <b-card >
                            <div slot="header">Shipping methods <b-button class="float-right" variant="success" @click="shippingMethod.sidebar = true"> Add </b-button></div>

                            <b-button class="m-2" v-for="(i, method) in settings.settings.shipping_methods" :key="method" pill @click="openEditorShippingMethod(method)"> {{ method }} </b-button>
                            <b-sidebar v-model="shippingMethod.sidebar" right title="Shipping method">
                                <b-col>
                                    <InputField name="code" label="Code" v-model="shippingMethod.code"
                                        :rules="{required:true}"
                                        :disabled="shippingMethod.mode == 'edit'"
                                    />

                                    <Texti18n name="shipping_name" label="Name" v-model="shippingMethod.name"
                                        :rules="{required:true}"
                                    />

                                    <Texti18n name="shipping_description" label="Description" v-model="shippingMethod.description"
                                        :rules="{required:false}"
                                    />

                                    <InputField type="number" name="freeAbove" label="Free above" v-model="shippingMethod.freeAbove"
                                        :rules="{required:true}"
                                    />

                                    <b-button class="mt-2 float-right" variant="success" @click="createNewShippingMethod" v-if="shippingMethod.mode == 'create'"> Create </b-button>
                                    <b-button class="mt-2 float-right" variant="primary" @click="editShippingMethod" v-if="shippingMethod.mode == 'edit'"> Edit </b-button>
                                </b-col>
                            </b-sidebar>

                        </b-card>
                        <b-card >
                            <div slot="header">Payment methods <b-button class="float-right" variant="success" @click="paymentMethod.sidebar = true"> Add </b-button></div>

                            <b-button class="m-2" v-for="(i, method) in settings.settings.payment_methods" :key="method" pill @click="openEditorPaymentMethod(method)"> {{ method }} </b-button>
                            <b-sidebar v-model="paymentMethod.sidebar" right title="Payment method">
                                <b-col>
                                    <InputField name="code" label="Code" v-model="paymentMethod.code"
                                        :rules="{required:true}"
                                        :disabled="paymentMethod.mode == 'edit'"
                                    />

                                    <Texti18n name="shipping_name" label="Name" v-model="paymentMethod.name"
                                        :rules="{required:true}"
                                    />

                                    <b-button class="mt-2 float-right" variant="success" @click="createNewPaymentMethod" v-if="paymentMethod.mode == 'create'"> Create </b-button>
                                    <b-button class="m-2 float-right" variant="primary" @click="editPaymentMethod" v-if="paymentMethod.mode == 'edit'"> Edit </b-button>
                                    <b-button class="m-2 float-right" variant="danger" @click="deletePaymentMethod" v-if="paymentMethod.mode == 'edit'"> Delete </b-button>
                                </b-col>
                            </b-sidebar>

                        </b-card>
                        <b-card >
                            <div slot="header">Countries</div>

                            <v-select v-model="settings.settings.countries" :options="countries" multiple />

                        </b-card>
                    </b-col>
                </b-row>

               
            </b-tab>
          </b-tabs>
          <b-card-footer>
               <b-button variant="success" @click="saveSettings"><b-spinner v-if="savingProgress" size="sm" /> <span v-else>Save</span></b-button>
          </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import Input from '@/components/form/Input'
import Texti18n from '@/components/form/Texti18n'
import ImageField from '@/components/form/Image'
import vSelect from 'vue-select'

export default {
    name: 'Storefront',
    components: {
        InputField: Input,
        ImageField,
        vSelect,
        Texti18n
    },
    data: function() {
        return {
            tabIndex: 0,
            savingProgress: false,
            settings: {
                hostname: '', 
                settings: {
                    shipping_methods: {},
                    payment_methods: {},
                    countries: [],
                    brand: {
                        logo: '',
                        primary_color: '',
                        secondary_color: ''
                    }
                }
            },
            errors: {
                hostname: null,
                logo: null,
                primaryColor: null,
                secondaryColor: null
            },
            shippingMethod: {
                sidebar: false,
                mode: 'create',
                code: '',
                name: {
                    locales: {}
                },
                description: {
                    locales: {}
                },
                freeAbove: 0
            },
            paymentMethod: {
                sidebar: false,
                mode: 'create',
                code: '',
                name: {
                    locales: {}
                },
                description: ''
            },
            countries: []
        }
    },

    computed: {
        logo: {
            get() {
                return this.settings.settings.brand.logo
            },

            set(val) {
                this.settings.settings.brand.logo = val.publicURL
            }
        }
    },

    methods: {
        saveSettings() {
            this.savingProgress = true;
            this.$integrationApi.post("storefront/settings", this.settings.settings).then(resp => {
                this.settings.settings = resp.data
                this.savingProgress = false;
            }).catch(err => {
                this.savingProgress = false;
                console.log(err)
            })
        },

        createNewShippingMethod() {
            let { shipping_methods = {} } = this.settings.settings
            if (shipping_methods === null) {
                shipping_methods = {}
            }

            shipping_methods[this.shippingMethod.code] = {
                label: this.shippingMethod.name,
                description: this.shippingMethod.description,
                freeAbove: this.shippingMethod.freeAbove
            }

            this.shippingMethod.code = ''
            this.shippingMethod.name = {
                locales: {}
            }
            this.shippingMethod.description = {
                locales: {}
            }
            this.shippingMethod.freeAbove = null

            this.settings.settings.shipping_methods = shipping_methods

            this.shippingMethod.sidebar = false;
        },

        openEditorShippingMethod(code) {
            this.shippingMethod.mode = 'edit';
            this.shippingMethod.code = code;

            // find by code
            let m = this.settings.settings.shipping_methods[code]

            this.shippingMethod.name = m.label
            this.shippingMethod.description = m.description
            this.shippingMethod.freeAbove = m.freeAbove

            this.shippingMethod.sidebar = true;
        },

        editShippingMethod() {
            let { shipping_methods } = this.settings.settings

            shipping_methods[this.shippingMethod.code] = {
                label: this.shippingMethod.name,
                description: this.shippingMethod.description,
                freeAbove: this.shippingMethod.freeAbove
            }

            this.shippingMethod.code = ''
            this.shippingMethod.name = {
                locales: {}
            }
            this.shippingMethod.description = {
                locales: {}
            }
            this.shippingMethod.freeAbove = null

            this.settings.settings.shipping_methods = m

            this.shippingMethod.sidebar = false;
        },

        deleteShippingMethod(method) {
           let methods = this.settings.settings.shipping_methods

            delete methods[this.shippingMethod.code]

            this.$set(this.settings.settings, 'shipping_methods', methods)

            this.shippingMethod.sidebar = false;
        },

        createNewPaymentMethod() {
            let { payment_methods = {} } = this.settings.settings
            if (payment_methods === null) {
                payment_methods = {}
            }

            payment_methods[this.paymentMethod.code] = this.paymentMethod.name

            this.paymentMethod.code = ''
            this.paymentMethod.name = {
                locales: {}
            }

            this.settings.settings.payment_methods = payment_methods
            this.paymentMethod.sidebar = false;
        },

        openEditorPaymentMethod(code) {
            this.paymentMethod.mode = 'edit';
            this.paymentMethod.code = code;

            // find by code
            let name = this.settings.settings.payment_methods[code]

            this.paymentMethod.name = name

            this.paymentMethod.sidebar = true;
        },

        editPaymentMethod() {
            let { payment_methods } = this.settings.settings

            payment_methods[this.paymentMethod.code] = this.paymentMethod.name

            this.paymentMethod.code = ''
            this.paymentMethod.name = {
                locales: {}
            }

            this.settings.settings.payment_methods = payment_methods

            this.paymentMethod.sidebar = false;
        },

        deletePaymentMethod() {
            let methods = this.settings.settings.payment_methods

            delete methods[this.paymentMethod.code]

            this.$set(this.settings.settings, 'payment_methods', methods)

            this.paymentMethod.sidebar = false;
        }
    },

    mounted() {
        this.$integrationApi.get("storefront/settings").then(resp => {
            this.settings = resp.data
        }).catch(err => {
            console.log(err)
        })

        this.$http.get("https://restcountries.com/v3.1/all").then(resp => {
            this.countries = resp.data.map(r => {
                return r.name.common
            })
        })
    }
}
</script>